export const severities = ['debug', 'info', 'warn', 'error'] as const;

export type Severity = (typeof severities)[number];

interface LogEntry {
	severity: Severity;
	tags?: string[];
	message: string[];
}

type LogMessageHandler = (logEntry: LogEntry) => unknown;

const createLogSystem = () => {
	const handlers = new Set<LogMessageHandler>();

	return {
		onMessage(handler: LogMessageHandler) {
			handlers.add(handler);
		},

		remove(handler: LogMessageHandler) {
			handlers.delete(handler);
		},

		emit(logEntry: LogEntry) {
			handlers.forEach((handler) => handler(logEntry));
		},
	};
};

export const logSystem = createLogSystem();

/** Convenience function for log listeners to filter out messages based on message severity */
export const severityMatches = (severity: Severity, verbosity: Severity) =>
	severities.indexOf(severity) >= severities.indexOf(verbosity);
